import { allCountries, allCountryCodes } from '../constants/country_data';

const educationList = [
  'High school',
  'Associate',
  "Bachelor's degree",
  "Master's degree",
  'Doctorate',
];

const gpaList = [
  '4.0',
  '3.7',
  '3.3',
  '3.0',
  '2.7',
  '2.3',
  '2.0',
  '1.7',
  '1.3',
  '1.0',
];

// const subjectsList = [
//   'Humanities',
//   'Social sciences',
//   'English & Literature',
//   'Business Studies',
//   'Math & Statistics',
//   'Environmental science',
//   'Finance & Economics',
//   'Computer science & IT',
//   'Chemistry',
//   'Physics & Engineering',
// ]

const academicExperience = [
  "Not yet, but I'm working on it ;)",
  'less than 1 year',
  '1 - 2 years',
  'more than 2 years'
];

const tutoringExperience = [
  'No',
  'less than 1 year',
  '1 - 2 years',
  'more than 2 years'
];

const hoursList = [
  'up to 5',
  '5-10',
  '10-20',
  '20-30',
  '30-40',
  '40+hours',
];

const monthlyIncome = [
  'up to $150',
  '$150 - $300',
  '$300 - $450',
  '$450 - $600',
  '$600 - $800',
  '$800 - $1000',
  '$1000 +',
]

const majorList = [
  'Academic Writing',
  'Aerodynamics',
  'Aerospace Engineering',
  'Agriculture, Fisheries and Food',
  'Algebra',
  'Analytics',
  'Anthropology',
  'Applied Mathematics',
  'Archaeology',
  'Art',
  'Art History',
  'Artificial Intelligence',
  'Astronomy',
  'Atmospheric Science',
  'Atomic Physics',
  'Behavioral Psychology',
  'Biology',
  'Biology and Life Sciences',
  'Business and Management',
  'Calculus',
  'Chemical Engineering',
  'Chemistry',
  'Civil Engineering',
  'Classical Music',
  'Cognitive Psychology',
  'Communication Studies',
  'Computer Science',
  'Creative Writing',
  'Criminology',
  'Culture',
  'Data Analytics',
  'Descriptive Analytics',
  'Descriptive Statistics',
  'Design and Architecture',
  'Ecology',
  'Economics',
  'Education',
  'Electrical Engineering',
  'Engineering',
  'English',
  'Environmental Science',
  'Ethics',
  'Experimental Psychology',
  'Finance, Accounting and Banking',
  'Forestry',
  'Game Theory',
  'Genetics and Heredity',
  'Geography',
  'Geology',
  'Geometry and Topology',
  'Governmental Studies',
  'Healthcare and Nursing',
  'History',
  'History and Anthropology',
  'History of Literature',
  'HRM',
  'Immunology',
  'Inferential Statistics',
  'Information Theory',
  'International Business',
  'International Economics',
  'International Politics',
  'International Relations',
  'Introduction to Visual Arts',
  'IT',
  'IT Security',
  'Journalism',
  'Labor and Employee Relations',
  'Law and International Law',
  'Life Sciences',
  'Linguistics',
  'Literature',
  'Logic',
  'Macroeconomics',
  'Managerial Analytics',
  'Marketing and PR',
  'Maths',
  'Mechanical Engineering',
  'Microbiology',
  'Microeconomics',
  'Military Studies',
  'Modern Physics',
  'Molecular Biology',
  'Morphology',
  'Music',
  'Music History',
  'Network Engineering',
  'Neuroscience',
  'Nuclear Physics',
  'Number Theory',
  'Nursing Theory',
  'Nutrition',
  'Organization Development',
  'Performance Arts',
  'Philosophy',
  'Phonology',
  'Physics',
  'Physiology',
  'Plant Sciences',
  'Political Behavior',
  'Political Economy',
  'Political Methodology',
  'Political Science',
  'Political Sociology',
  'Probability and Statistics',
  'Programming',
  'Project Management',
  'Psycholinguistics',
  'Psychology',
  'Public Health',
  'Religion',
  'Semantics and Pragmatics',
  'Sociology',
  'Sociology of Economy',
  'Software Engineering',
  'Statistics',
  'Syntax',
  'Theology',
  'Theories of Modern Art',
  'Thermodynamics',
  'Visual Arts',
  'Web Development',
];

const minorList = [...majorList];
let countryList = allCountries.map(c => c.name);
countryList = [...new Set(countryList)];

export { educationList, gpaList, academicExperience, tutoringExperience, majorList, minorList, countryList, hoursList, monthlyIncome };



// WEBPACK FOOTER //
// ./src/constants/applicant_info.js